import { Injectable } from "@angular/core";
import { databases, ID, storage } from "../config/appwrite";
import { environment } from "../../../environments/environment";
import { Servicio } from "../models";
import { Query } from "appwrite";

@Injectable({
  providedIn: "root",
})
export class ServiciosService {
  private collectionId = "servicios";
  private DATABASE_NAME = environment.databaseName;

  constructor() {}

  /**
   * @getData()
   * @returns
   */
  getData(): Promise<Servicio[]> {
    return databases
      .listDocuments<Servicio>(this.DATABASE_NAME, this.collectionId)
      .then((response) => response.documents);
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: Servicio) {
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }
  createDocument2(data: any) {
    return databases.createDocument(
      this.DATABASE_NAME,
      this.collectionId,
      ID.unique(),
      data
    );
  }

  /**
   * @getDocument()
   * @param idDocument
   * @returns
   */
  getDocument(idDocument: string) {
    return databases.getDocument(
      this.DATABASE_NAME,
      this.collectionId,
      idDocument
    );
  }

  /**
   *getServicios
   * @returns
   */
  getServicios(): Promise<Servicio[]> {
    return databases
      .listDocuments<Servicio>(this.DATABASE_NAME, this.collectionId)
      .then((response) => response.documents);
  }

  /**
   * getPaquetes();
   * @returns
   */
  getPaquetes(): Promise<Servicio[]> {
    return databases
      .listDocuments<Servicio>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("tServicio", "661d51a80025c96a07cc"),
      ])
      .then((response) => response.documents);
  }

  /**
   *
   * @param modalidad
   * @returns
   */

  // Version antigua.. no usar más.
  getDocumentsByModalidad(modalidad: string): Promise<Servicio[]> {
    return databases
      .listDocuments<Servicio>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("modalidad", [modalidad]),
        Query.equal("activo", true),
        Query.orderDesc("fHasta"), // Ordenamiento descendente por fHasta
        Query.limit(50), // Límite de 50 registros
      ])
      .then((response) => response.documents);
  }

  // Versión nueva.
  // Se incluye los arrays de los especialistas para que lo haga directamente en la consulta
  getDocumentsByModalidadIncludeArray(
    modalidad: string,
    ids: string[]
  ): Promise<Servicio[]> {
    return databases
      .listDocuments<Servicio>(this.DATABASE_NAME, this.collectionId, [
        Query.equal("modalidad", [modalidad]),
        Query.equal("activo", true),
        Query.equal("$id", ids), // Filtrar por los IDs proporcionados
        Query.orderDesc("fHasta"),
        Query.limit(50),
      ])
      .then((response) => response.documents);
  }
}
